module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.sForm.ad_status === 3) ? _c('el-alert', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "title": _vm.errorTip,
      "type": "error"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m_context plr"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "sForm",
    attrs: {
      "model": _vm.sForm,
      "label-width": "80px",
      "rules": _vm.editRules
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sForm.ad_id),
      expression: "sForm.ad_id"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.sForm.ad_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sForm, "ad_id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.name'),
      "prop": "ad_title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.sForm.ad_title),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "ad_title", $$v)
      },
      expression: "sForm.ad_title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.classify'),
      "prop": "ad_type"
    }
  }, [_c('el-select', {
    staticClass: "w_33",
    attrs: {
      "placeholder": _vm.$t('lin_global.qxzlx')
    },
    model: {
      value: (_vm.sForm.ad_type),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "ad_type", $$v)
      },
      expression: "sForm.ad_type"
    }
  }, _vm._l((_vm.adTypeList), function(item, index) {
    return _c('el-option', {
      key: item.adtypeId,
      attrs: {
        "label": item.adtypeName,
        "value": item.adtypeId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.position'),
      "prop": "ad_position"
    }
  }, [_c('el-select', {
    staticClass: "w_33",
    attrs: {
      "placeholder": _vm.$t('app_selectPlayPlace')
    },
    model: {
      value: (_vm.sForm.ad_position),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "ad_position", $$v)
      },
      expression: "sForm.ad_position"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('advert.positionSub.banner'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('advert.positionSub.starPage'),
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('app_appadv'),
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.jumpType')
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.sForm.ad_Urltype),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "ad_Urltype", $$v)
      },
      expression: "sForm.ad_Urltype"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '0'
    }
  }, [_vm._v(_vm._s(_vm.$t('advert.jumpTypeSub.net')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v(_vm._s(_vm.$t('advert.jumpTypeSub.appStore')))])], 1)], 1), _vm._v(" "), (_vm.sForm.ad_Urltype === '1') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.app'),
      "prop": "ad_url"
    }
  }, [(_vm.appName) ? _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.choiceAppVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.appName))]) : _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.choiceAppVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sapp')))])], 1) : _vm._e(), _vm._v(" "), (_vm.sForm.ad_Urltype === '0') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.url'),
      "prop": "ad_url"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.sForm.ad_url),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "ad_url", $$v)
      },
      expression: "sForm.ad_url"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.channel'),
      "prop": "ad_channel"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true,
      "classs": 'w_33'
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.ableDate')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd hh:mm",
      "picker-options": _vm.pickerOptions0,
      "placeholder": _vm.$t('advert.beginDate')
    },
    model: {
      value: (_vm.sForm.ad_start_date),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "ad_start_date", $$v)
      },
      expression: "sForm.ad_start_date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd hh:mm",
      "picker-options": _vm.pickerOptions1,
      "placeholder": _vm.$t('advert.endDate')
    },
    model: {
      value: (_vm.sForm.ad_start_end),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "ad_start_end", $$v)
      },
      expression: "sForm.ad_start_end"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.contentImg'),
      "prop": "ad_imgUrl"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.adUlld),
      expression: "adUlld"
    }],
    staticStyle: {
      "padding": "10px"
    }
  }, [(_vm.isscale) ? _c('div', [_c('croppa', {
    staticStyle: {
      "zoom": "0.5",
      "padding-top": "38px"
    },
    attrs: {
      "placeholder-font-size": 30,
      "placeholder": _vm.$t('app_spic'),
      "width": 360,
      "height": _vm.psize,
      "prevent-white-space": true,
      "iinitial-image": "dfImg",
      "remove-button-color": '#409EFF'
    },
    model: {
      value: (_vm.croppa),
      callback: function($$v) {
        _vm.croppa = $$v
      },
      expression: "croppa"
    }
  }, [_c('img', {
    attrs: {
      "slot": "initial",
      "crossOrigin": "anonymous",
      "src": _vm.dfImg
    },
    slot: "initial"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": ""
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_upload')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#AAAEBA",
      "margin-top": "8px",
      "width": "700px",
      "background": "none"
    }
  }, [_vm._v(_vm._s(_vm.sizeTip))])], 1) : _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "before-upload": _vm.upload1,
      "ffile-list": "fileList"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.getImgName()))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [(!_vm.isscale && _vm.sForm.ad_imgUrl) ? _c('img', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "src": _vm.$host + _vm.sForm.ad_imgUrl
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('el-checkbox', {
    on: {
      "change": _vm.scaleChange
    },
    model: {
      value: (_vm.isscale),
      callback: function($$v) {
        _vm.isscale = $$v
      },
      expression: "isscale"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_propcut')))])], 1)]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.cancel')))]), _vm._v(" "), (_vm.sForm.ad_id === '0') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.createAdvert
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.add')))]) : [(_vm.sForm.ad_status == 0 || _vm.sForm.ad_status == 3 || _vm.sForm.ad_status == 4 || _vm.sForm.ad_status == 5) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateAdvert
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.update')))]) : _vm._e()]], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_sapp'),
      "visible": _vm.choiceAppVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.choiceAppVisible = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('advert.appName')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_iappnamesrch')
    },
    model: {
      value: (_vm.tmp_appName),
      callback: function($$v) {
        _vm.tmp_appName = $$v
      },
      expression: "tmp_appName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getAppListByName
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.tip.search')))])], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.appList
    },
    on: {
      "cell-click": _vm.choiceAppRecord
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "appName",
      "label": _vm.$t('advert.appSub.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "appCategoryName",
      "label": _vm.$t('advert.appSub.classify')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "chekcTime",
      "label": _vm.$t('advert.appSub.uploadTime'),
      "formatter": _vm.dateFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "appVersion",
      "label": _vm.$t('advert.appSub.version')
    }
  })], 1), _vm._v(" "), _c('paging', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "rdata": _vm.pagingData,
      "action": _vm.pAction,
      "arraySize": "[5,8]"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.choiceAppVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.cancel')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0568ebb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/advert/advert-edit.vue
// module id = 956
// module chunks = 0